// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"196":"61e1230317f628758ce0","229":"3fea9803098ad45b3aae","514":"0f6b4bd7876311d3851b","530":"bd13d74d294b1dd9ef35","559":"d9235f2f39c293397a2f","653":"0ece7645255768c790f1","858":"fa04281be3af37e70d2c","891":"2a59b0981f13aa60aec7"}[chunkId] + ".js";
};